import { List, Map, Record } from 'immutable';

import CompanyRecord from 'records/company';
import EmailSettingsRecord from 'records/emailSettings';
import ListingRecord from 'records/listing';
import PageRecord from 'records/page';
import ProductRecord from 'records/product';

export default Record({
    action: null,
    applications: List(),
    boost: null,
    company: CompanyRecord(),
    companyId: null,
    dailyLimit: null,
    discountPrice: null,
    emailsCollectedCount: null,
    emailSettings: EmailSettingsRecord(),
    endsAt: '',
    featuredOn: List(),
    features: List(),
    flags: [],
    followups: List(),
    funds: false,
    id: null,
    impressionTotals: Map(),
    isExclusive: false,
    isFunded: false,
    isMultiUse: false,
    isSingleUse: false,
    isSyndicated: null,
    isUnderperforming: false,
    limit: 0,
    listing: ListingRecord(),
    listingId: null,
    maxQuantityDisclaimer: false,
    metadata: Map(),
    moneySaved: null,
    multiUsePromotion: Map(),
    name: '',
    note: null,
    ordersCount: null,
    page: PageRecord(),
    percentageOff: null,
    platforms: null,
    product: ProductRecord(),
    productId: null,
    recentOrdersCount: null,
    remainingQuantity: null,
    requireEmail: true,
    returnAt: null,
    rewardCodes: List(),
    singleUsePromotions: List(),
    startsAt: '',
    state: null,
    timezone: 'US/Pacific',
    type: '',
}, 'Campaign');
